<template>
    <div id="container" ref="container">
        <div id="topContainer">
            <transition appear name="appear">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <!-- <div class="swiper-slide">Slide 1</div> -->
                        <!-- <div class="swiper-slide">Slide 2</div> -->
                        <!-- <div class="swiper-slide">Slide 3</div> -->
                        <!-- <div class="swiper-slide">Slide 4</div> -->
                        <!-- <div class="swiper-slide">Slide 5</div> -->
                        <!-- <div class="swiper-slide">Slide 6</div> -->
                        <!-- <div class="swiper-slide">Slide 7</div> -->
                        <!-- <div class="swiper-slide">Slide 8</div> -->
                        <!-- <div class="swiper-slide">Slide 9</div> -->

                        <div
                            class="buttonPrev"
                            :class="{ random: store.random }"
                        ></div>
                        <div
                            class="buttonNext"
                            :class="{ random: store.random }"
                        ></div>
                    </div>
                </div>
            </transition>
            <div id="titleContainer">
                <!-- <div id="mobileCounter" class="tabNum"> -->
                <!--     {{ formatNumber(getSwiperIdx() + 1) }}/{{ -->
                <!--         formatNumber(store.swipeImages.length) -->
                <!--     }} -->
                <!-- </div> -->

                <div id="counter" class="tabNum">
                    {{ formatNumber(counter) }} /
                    {{ formatNumber(store.swipeImages.length) }}
                </div>
                <div id="title">
                    {{ currentProject.title }}&emsp;
                    <span v-if="!allowScroll" @click="openBottom">More</span>
                    <span v-else @click="closeBottom">Close</span>
                </div>
            </div>
        </div>

        <div id="bottomContainer" v-show="allowScroll">
            <p id="text" v-html="currentProject.text"></p>
            <div
                v-if="
                    (currentProject.infos && currentProject.infos.length) ||
                        currentProject.link
                "
                id="infos"
            >
                <p
                    class="tabNum"
                    v-for="info in currentProject.infos"
                    v-html="info.text"
                ></p>
                <a :href="currentProject.link" target="_blank">{{
                    currentProject.link_text
                }}</a>
            </div>
            <div id="bottomImages" ref="images">
                <div
                    v-for="(image, idx) in projectImages"
                    class="imageElement"
                    @click="handleBottomImageClick(image.id)"
                    :style="{
                        width: getDivWidth(image),
                        flexGrow: getDivFlex(image)
                    }"
                >
                    <i :style="{ paddingBottom: getIPadding(image) }"></i>
                    <img
                        :src="image.thumbnail_small"
                        :class="getClasses(image)"
                    />
                    <img
                        v-if="image.is_paired_with_next"
                        :src="getNextImage(image).thumbnail_small"
                        :class="getClasses(image)"
                    />
                    <img
                        v-if="
                            image.is_paired_with_next &&
                                getNextImage(image).is_paired_with_next
                        "
                        :class="getClasses(image)"
                        :src="getNextImage(getNextImage(image)).thumbnail_small"
                    />
                    <div
                        class="number tabNum"
                        v-html="
                            formatNumber(
                                store.orderedImages.findIndex(
                                    i => i.id == image.id
                                ) + 1
                            )
                        "
                    ></div>
                </div>
                <div
                    class="image"
                    v-for="(image, idx) in projectImages"
                    @click="handleBottomImageClick(image.id)"
                >
                    <div
                        class="images"
                        :class="{ paired: image.is_paired_with_next }"
                    >
                        <img
                            :src="image.thumbnail_small"
                            :class="getClasses(image)"
                        />
                        <img
                            v-if="image.is_paired_with_next"
                            :src="getNextImage(image).thumbnail_small"
                            :class="getClasses(image)"
                        />
                        <img
                            v-if="
                                image.is_paired_with_next &&
                                    getNextImage(image).is_paired_with_next
                            "
                            :class="getClasses(image)"
                            :src="
                                getNextImage(getNextImage(image))
                                    .thumbnail_small
                            "
                        />
                    </div>
                    <div
                        class="number tabNum"
                        v-html="
                            formatNumber(
                                store.orderedImages.findIndex(
                                    i => i.id == image.id
                                ) + 1
                            )
                        "
                    ></div>
                </div>
            </div>
            <!-- <section v-else id="mobileImages"> -->
            <!--     <div -->
            <!--         v-for="(image, idx) in projectImages" -->
            <!--         class="" -->
            <!--         @click="handleBottomImageClick(image.id)" -->
            <!--     > -->
            <!--         <img -->
            <!--             :src="image.thumbnail_small" -->
            <!--             :class="getClasses(image)" -->
            <!--         /> -->
            <!--         <img -->
            <!--             v-if="image.is_paired_with_next" -->
            <!--             :src="getNextImage(image).thumbnail_small" -->
            <!--             :class="getClasses(image)" -->
            <!--         /> -->
            <!--         <img -->
            <!--             v-if=" -->
            <!--                 image.is_paired_with_next && -->
            <!--                     getNextImage(image).is_paired_with_next -->
            <!--             " -->
            <!--             :class="getClasses(image)" -->
            <!--             :src="getNextImage(getNextImage(image)).thumbnail_small" -->
            <!--         /> -->
            <!--         <!-- </div> -->
            <!--         <div -->
            <!--             class="number tabNum" -->
            <!--             v-html=" -->
            <!--                 formatNumber( -->
            <!--                     store.orderedImages.findIndex( -->
            <!--                         i => i.id == image.id -->
            <!--                     ) + 1 -->
            <!--                 ) -->
            <!--             " -->
            <!--         ></div> -->
            <!--     </div> -->
            <!-- </section> -->
        </div>
    </div>
</template>

<script>
import Swiper from "swiper";
import { Virtual, EffectFade, Navigation } from "swiper/modules";

import "swiper/swiper-bundle.css";

import { store } from "@/centralStore";
import api from "@/api";
import SwipeImage from "@/components/SwipeImage";
import Vue from "vue";

export default {
    name: "Swipe",
    data() {
        return {
            store: store.state,
            swiperInstance: null,
            images: [],
            allowScroll: false,
            lastScrollDelta: 0,
            scrollTimeout: false,
            mountedImages: [],
            counter: 0
        };
    },

    watch: {
        "store.swipeImages": {
            handler(val, oldVal) {
                //console.log("watch swipeImages");
                this.createSwiper(val);
            }
            // immediate: true
        },
        "store.orderedImages": {
            handler(val, oldVal) {
                //console.log("watch orderedImages");
                this.createSwiper(val);
            }
            // immediate: true
        },
        "$route.params.id": function() {
            //console.log("swiperIdx", this.getSwiperIdx());
            this.swiperInstance.slideTo(this.getSwiperIdx(), 300, false);
        }
        //$route: function() {
        //console.log("route");
        //this.swiperInstance.slideTo(this.getSwiperIdx(), 300, false);
        //}
    },
    methods: {
        createSwiper(images) {
            // console.log("------------");
            // console.log(
            //     "create swiper",
            //     images.map(i => i.project)
            // );
            //console.log(images.map(i => i.id));
            //console.log(this.store.shuffledImages.map(i => i.id));
            //console.log(this.store.orderedImages.map(i => i.id));
            var ComponentClass = Vue.extend(SwipeImage);
            this.images = images.map(
                i =>
                    new ComponentClass({
                        propsData: { image: i }
                    })
            );
            // if (this.images) {
            //     this.images.forEach(i => i.$destroy())
            // }
            this.images.forEach(i => i.$mount());

            this.mountedImages = this.images.map(i => i.$el.outerHTML);
            // console.log(this.images)
            // console.log(mountedImages)
            let params = {
                modules: [Virtual, Navigation],
                virtual: {
                    slides: this.mountedImages,
                    // slides: this.images,
                    addSlidesAfter: 1,
                    addSlidesBefore: 1
                    // renderSlide: function (slide, index) {
                    //     let html = slide.$mount().$el.outerHTML
                    //     console.log(index)
                    //     console.log(html)
                    //     return html
                    // }
                },
                slidesPerView: 1,
                centeredSlides: true,
                // lazyPreloadPrevNext: 3,
                on: {
                    // click: function() {
                    //     this.slideNext();
                    // },
                    slideChange: this.updateRoute
                },
                effect: "slide",
                speed: 300,
                observer: true,
                navigation: {
                    nextEl: ".buttonNext",
                    prevEl: ".buttonPrev"
                }
            };
            if (window.innerWidth >= 768) {
                params.modules.push(EffectFade);
                params.effect = "fade";
                params.fadeEffect = { crossFade: true };
                params.fadeEffect.crossFade = true;
                params.speed = 300;
                // params.crossFade = true
            }
            if (this.swiperInstance) {
                this.swiperInstance.off("slideChange", this.updateRoute);
                this.swiperInstance.virtual.removeAllSlides();
                this.swiperInstance.virtual.update();
                this.swiperInstance.virtual.appendSlide(this.mountedImages);
                this.swiperInstance.on("slideChange", this.updateRoute);
                this.swiperInstance.slideTo(this.getSwiperIdx(), 0, false);
            } else {
                let myself = this;
                setTimeout(function() {
                    myself.swiperInstance = new Swiper(
                        ".swiper-container",
                        params
                    );
                    // console.log("route id", myself.$route.params.id);
                    // console.log("swiperIDX", myself.getSwiperIdx());
                    myself.swiperInstance.slideTo(
                        myself.getSwiperIdx(),
                        0,
                        false
                    );
                    // myself.updateRoute();

                    setTimeout(function() {
                        if (myself.$route.name == "swipe") {
                            // console.log("push 1");
                            myself.$router.push({
                                name: "swipe-image",
                                params: {
                                    slug: myself.currentImage.project_slug,
                                    id: myself.currentImage.id
                                }
                            });
                        } else if (myself.$route.name == "swipe-slug") {
                            // console.log("push 2");
                            myself.$router.push({
                                name: "swipe-image",
                                params: {
                                    slug: myself.$route.params.slug,
                                    id: myself.store.swipeImages.find(
                                        i =>
                                            i.project_slug ==
                                            myself.$route.params.slug
                                    ).id
                                }
                            });
                        }

                        setTimeout(function() {
                            myself.updateRoute();
                        }, 200);
                    }, 200);
                }, 200);
            }
        },
        createSlide(image) {
            let el = document.createElement("div");
            let i = document.createElement("img");
            i.src = image.thumbnail_big;
            el.appendChild(i);
            return el.outerHTML;
        },
        handleBottomImageClick(id) {
            // this.swiper.slideTo(idx, 300, false)
            this.store.random = false;
            this.store.swipeImages = this.store.orderedImages;
            let myself = this;
            setTimeout(function() {
                myself.swiperInstance.slideTo(
                    myself.store.orderedImages.findIndex(i => i.id == id),
                    300
                );
            }, 200);
        },
        updateCounter() {
            const myself = this;

            let count = 0;
            if (this.store.random) {
                const interval = setInterval(() => {
                    myself.counter = Math.floor(Math.random() * 10000);
                    count++;
                    if (count >= 5) {
                        clearInterval(interval);
                        myself.counter = myself.getTotalIdx() + 1;
                    }
                }, 100);
            } else {
                myself.counter = myself.getTotalIdx() + 1;
            }
        },
        updateRoute() {
            const myself = this;
            //console.log(this.currentImage.id);
            let idx = this.store.swipeImages.findIndex(
                im => im.id == this.currentImage.id
            );
            this.store.currentSwipeID = this.currentImage.id;
            if (idx != -1) {
                this.store.lastSwipeIDX = idx;
            }
            // this.scrollTop();
            this.closeBottom();

            if (
                this.$route.params.slug != this.currentImage.project_slug ||
                this.$route.params.id != this.currentImage.id
            ) {
                this.$router.push({
                    name: "swipe-image",
                    params: {
                        slug: this.currentImage.project_slug,
                        id: this.currentImage.id
                    }
                });
                // console.log("not route push");
            }
            this.updateCounter();
            this.store.lastSwipe = this.$route.path;
            // console.log(this.store.lastSwipe);
            // this.store.swiperInstance.update()
        },
        getSwiperIdx() {
            return this.store.swipeImages.findIndex(
                i => i.id == this.$route.params.id
            );
        },
        getTotalIdx() {
            return this.store.orderedImages.findIndex(
                i => i.id == this.$route.params.id
            );
        },
        arrayRange(start, stop, step) {
            return Array.from(
                { length: (stop - start) / step + 1 },
                (value, index) => start + index * step
            );
        },

        getNextImage(image) {
            let allImagesIdx = this.store.allImages.findIndex(
                i => i.id == image.id
            );
            return this.store.allImages[allImagesIdx + 1];
        },
        formatNumber(number) {
            if (number && number != "" && number != 0) {
                return number.toString().padStart(4, "0");
            } else {
                return "0000";
            }
        },
        scrollBottom() {
            let myself = this;
            // this.allowScroll = true;
            // if (window.innerWidth > 768) {
            // setTimeout(function () {
            //     myself.$refs.container.scrollTo({
            //         top: 1000,
            //         left: 0,
            //         behavior: 'smooth',
            //     });
            // }, 100)

            // var rem = 20;
            // var contentHeight =
            // this.$refs.scrollContainer.offsetHeight + rem;
            // var windowHeight = window.innerHeight;

            // var margin = windowHeight - contentHeight;
            // this.$refs.scrollContainer.style.marginTop = margin + "px";
            // } else {

            const el = myself.$refs.images;

            // Use el.scrollIntoView() to instantly scroll to the element

            if (el) {
                setTimeout(function() {
                    el.scrollIntoView({ behavior: "smooth" });
                    // myself.$refs.container.scrollTo({
                    //     top: 175,
                    //     left: 0,
                    //     behavior: "smooth"
                    // });
                }, 100);
            }
            // }
        },
        scrollTop() {
            let myself = this;
            // if (window.innerWidth > 768) {
            // this.$refs.scrollContainer.style.marginTop = "0";
            // } else {
            let html = document.querySelector("html");
            html.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            // }
            // setTimeout(function() {
            // myself.allowScroll = false;
            // }, 500);
        },
        openBottom() {
            this.allowScroll = true;
            this.scrollBottom();
        },
        closeBottom() {
            this.scrollTop();
            let myself = this;
            setTimeout(function() {
                myself.allowScroll = false;
            }, 400);
        },
        getDivWidth(image) {
            if (window.innerWidth <= 768) {
                if (
                    image.is_paired_with_next &&
                    this.getNextImage(image).is_paired_with_next
                ) {
                    //return image.width*360/image.height + window.innerWidth*0.005 + 'px'
                    return (
                        (image.width * 190) / image.height +
                        window.innerWidth * 0.005 +
                        "px"
                    );
                } else if (image.is_paired_with_next) {
                    return (
                        (image.width * 120) / image.height +
                        window.innerWidth * 0.005 +
                        "px"
                    );
                } else {
                    return (image.width * 60) / image.height + "px";
                }
            } else {
                if (
                    image.is_paired_with_next &&
                    this.getNextImage(image).is_paired_with_next
                ) {
                    //return image.width*360/image.height + window.innerWidth*0.005 + 'px'
                    return (
                        (image.width * 370) / image.height +
                        window.innerWidth * 0.005 +
                        "px"
                    );
                } else if (image.is_paired_with_next) {
                    return (
                        (image.width * 240) / image.height +
                        window.innerWidth * 0.005 +
                        "px"
                    );
                } else {
                    return (image.width * 120) / image.height + "px";
                }
            }
        },
        getDivFlex(image) {
            if (window.innerWidth <= 768) {
                if (
                    image.is_paired_with_next &&
                    this.getNextImage(image).is_paired_with_next
                ) {
                    return (image.width * 190) / image.height;
                } else if (image.is_paired_with_next) {
                    return (image.width * 120) / image.height;
                } else {
                    return (image.width * 60) / image.height;
                }
            } else {
                if (
                    image.is_paired_with_next &&
                    this.getNextImage(image).is_paired_with_next
                ) {
                    return (image.width * 360) / image.height;
                } else if (image.is_paired_with_next) {
                    return (image.width * 240) / image.height;
                } else {
                    return (image.width * 120) / image.height;
                }
            }
        },
        getIPadding(image) {
            if (
                image.is_paired_with_next &&
                this.getNextImage(image).is_paired_with_next
            ) {
                return (image.height / image.width) * 32 + "%";
            } else if (image.is_paired_with_next) {
                return (image.height / image.width) * 48.5 + "%";
            } else {
                return (image.height / image.width) * 101 + "%";
            }
        },

        handleKey(e) {
            //window.addEventListener('keydown', (e) => {
            if (e.key == "ArrowRight") {
                if (window.innerWidth > 768) {
                    this.swiperInstance.slideNext();
                } else {
                    this.swiperInstance.slideNext(300);
                }
            } else if (e.key == "ArrowLeft") {
                if (window.innerWidth > 768) {
                    this.swiperInstance.slidePrev();
                } else {
                    this.swiperInstance.slidePrev(300);
                }
            }

            //});
        },
        handleScroll(e) {
            let myself = this;
            if (!myself.scrollTimeout) {
                if (Math.abs(e.deltaY) >= myself.lastScrollDelta) {
                    myself.lastScrollDelta = Math.abs(e.deltaY);
                    if (e.deltaY < 0) {
                        myself.closeBottom();
                    } else if (e.deltaY > 0 && !myself.bottom) {
                        myself.openBottom();
                    }
                    myself.scrollTimeout = true;
                }
                setTimeout(function() {
                    myself.scrollTimeout = false;
                    myself.lastScrollDelta = 0;
                }, 100);
            }
        },

        getClasses(image) {
            return {
                websiteImage: image.is_website,
                lightBorder: image.border == "LI",
                darkBorder: image.border == "DA",
                double: image.is_paired_with_next,
                triple:
                    image.is_paired_with_next &&
                    this.getNextImage(image).is_paired_with_next
            };
        },
        handleMediaChange(e) {
            if (this.swiperInstance) {
                this.swiperInstance.off("slideChange", this.updateRoute);
                this.swiperInstance.virtual.removeAllSlides();
                this.swiperInstance.virtual.update();
                this.swiperInstance.destroy();
                this.swiperInstance = null;
                this.createSwiper(this.store.swipeImages);
            }
        }
    },
    created() {
        if (this.store.splashAllowed == true) {
            // this.store.urlAfterSplash = {
            //     name: this.$route.name,
            //     params: this.$route.params
            // };

            // console.log("swipe", this.store.afterSplashId);
            // console.log("swipe", this.store.afterSplashSlug);
            this.store.afterSplashName = this.$route.name;
            this.store.afterSplashSlug = this.$route.params.slug;
            this.store.afterSplashId = this.$route.params.id;
            this.$router.push({ name: "splash-dev" });
        }
    },
    mounted() {
        // if (window.innerWidth > 768) {
        // window.addEventListener("wheel", this.handleScroll);
        // window.addEventListener("keydown", this.handleKey);
        // }
        this.store.lastAbout = "studio-dev";
        this.store.lastIndex = "images-dev";

        if (this.store.orderedImages.length) {
            // this.store.swipeImages = this.store.shuffledImages;
            this.createSwiper(this.store.swipeImages);
        }
        this.mediaQuery = window.matchMedia("(min-width: 768px)");
        this.mediaQuery.addListener(this.handleMediaChange);

        if (window.innerWidth > 768) {
            window.addEventListener("wheel", this.handleScroll);
        }
    },
    beforeDestroy() {
        this.mediaQuery.removeListener(this.handleMediaChange);
        window.removeEventListener("wheel", this.handleScroll);
    },
    updated() {},
    activated() {},
    computed: {
        currentImageIdx() {
            if (this.swiperInstance) {
                return this.swiperInstance.activeIndex;
            } else {
                return null;
            }
        },
        currentImage() {
            if (this.swiperInstance) {
                return this.store.swipeImages[this.swiperInstance.activeIndex];
            } else {
                return null;
            }
        },

        currentProject() {
            if (this.swiperInstance) {
                let project = this.store.projects.find(
                    p => p.slug == this.currentImage.project_slug
                );
                return project;
            } else {
                return { title: "", images: [] };
            }
        },
        projectImages() {
            let project = this.currentProject;
            let images = project.images;
            let allImages = images;

            if (project.show_client) {
                let clientImages = this.store.orderedImages.filter(i => {
                    return (
                        i.client_rel == project.client_rel &&
                        i.category == project.category.name
                    );
                });
                images = clientImages;
                allImages = this.store.orderedImages;
            }

            return images.filter(image => {
                let idx = allImages.findIndex(i => i.id == image.id);
                if (idx == 0 || !allImages[idx - 1].is_paired_with_next) {
                    return image;
                }
            });
        }
    }
};
</script>

<style scoped>
#container {
    /* display: flex; */
    /* flex-direction: column; */
    /* margin-bottom: 1rem; */
    /* height: 100vh; */
    /* height: 100dvh; */
    /* overflow: hidden; */
}

#container.scroll {
    overflow: auto;
}

#scrollContainer {
    transition: margin 0.5s;
}

.swiper-container {
    height: 90%;
    overflow: hidden;
    /* margin-top: 9.9rem; */
}

@media screen and (min-width: 768px) {
    .swiper-container {
        margin-top: 0;
    }
}

#topContainer {
    width: 100%;
    height: calc(100vh - 10rem);
    height: calc(100dvh - 10rem);
    display: flex;
    flex-direction: column;
    gap: 2rem;
    justify-content: space-between;
}
@media screen and (min-width: 768px) {
    #topContainer {
        height: calc(100vh - 8rem);
        height: calc(100dvh - 8rem);
    }
}

.swiper-wrapper {
    min-height: 0;
}
#bottomContainer {
    padding-bottom: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
}

#bottomImages {
    display: flex;
    /* align-self: flex-start; */
    /* overflow: hidden; */
    flex-wrap: wrap;
    gap: 0.5rem;
    margin: 2rem 1rem 0;
    position: relative;
    /* display: grid; */
    /* width: 100%; */
    /* grid-template-columns: */
    /* repeat(auto-fit, minmax(250px, 1fr)); */
    align-items: center;
    justify-content: center;
    position: relative;
    /* grid-template-columns: repeat(auto-fit, minmax(min-content, max-content)); */
}

#bottomImages::after {
    content: "";
    flex-grow: 999999999;
}
@media screen and (min-width: 768px) {
    #bottomImages::after {
        flex-grow: 0;
    }
}
.imageElement {
    position: relative;
}
@media screen and (min-width: 768px) {
    .imageElement {
        display: none;
    }
}
.images {
    flex-direction: row;
    gap: 0.5rem;
    overflow: hidden;
    display: contents;
}
@media screen and (min-width: 768px) {
    .images.paired {
        height: 140px;
    }
}

.image {
    display: none;
    flex-direction: column;
    gap: 0.5rem;
    /* align-items: center; */
    position: relative;
    cursor: pointer;
}
@media screen and (min-width: 768px) {
    .image {
        display: flex;
    }
}

.image img {
    /* height: 120px; */
    vertical-align: bottom;
    /* height: 100%; */
    width: auto;
    /* object-fit: cover; */
    min-height: 0;
    height: 20vw;
    /* height: 100%; */
}

.images.paired {
    display: flex;
    height: 20vw;
}
@media screen and (min-width: 768px) {
    .image img {
        height: 140px;
    }
    .images.paired {
        height: 140px;
    }
}

i {
    display: block;
}

.imageElement img {
    position: absolute;
    top: 0;
    width: 100%;
    vertical-align: bottom;
    object-fit: cover;
    cursor: pointer;
}
.imageElement img.websiteImage {
    /*box-shadow: 0px 0px 0.3rem 0px #d2d2d2;*/
    border-radius: 0.25rem;
}
.imageElement img.double {
    width: calc(50% - 0.25rem);
}
.imageElement img.double:nth-child(3) {
    left: calc(50% + 0.25rem);
}
.imageElement img.triple {
    width: calc(33% - 0.25rem);
}
.imageElement img.triple:nth-child(3) {
    left: calc(33% + 0.25rem);
}
.imageElement img.triple:nth-child(4) {
    left: calc(66% + 0.5rem);
}

.pairedImages {
    display: flex;
    gap: 0.5rem;
}

#counter {
    /*margin-top: 3.6rem;*/
    /* align-self: center; */
    /* visibility: hidden; */
    text-align: center;
}

#mobileCounter {
    align-self: center;
    text-align: center;
    display: none;
}

@media screen and (min-width: 768px) {
    #mobileCounter {
        /*display: none;*/
    }

    #counter {
        /*margin-top: 0.8rem;*/
        /*display: block;*/
        /*visibility: visible;*/
    }
}

.number {
    color: rgb(150, 150, 150);
    text-align: center;
    /* margin: 0.25rem 0 0.08rem; */
}

@media screen and (min-width: 768px) {
    .image:hover .number {
        color: white;
    }
}

#title {
    text-align: center;
}
#title > span {
    color: #969696;
    cursor: pointer;
}

#titleContainer {
    align-self: center;
    margin: 0 1rem;
}

@media screen and (min-width: 768px) {
    #titleContainer {
        margin-bottom: 0;
    }
}

@media screen and (min-width: 768px) {
    #title > span:hover {
        color: white;
    }
}

@media screen and (min-width: 768px) {
    #title {
    }
}

#text >>> a {
    color: #969696;
    text-decoration: none;
}

@media screen and (min-width: 768px) {
    #text >>> a:hover {
        color: white;
    }
}

#text {
    margin: 2rem 1rem 0;
    text-align: center;
}

#infos {
    margin: 0 1rem 1rem;
    text-align: center;
}
@media screen and (min-width: 768px) {
    #infos {
        max-width: 736px;
    }
}

#infos p {
    margin: 0 !important;
}

#infos > span {
    margin-right: 1rem;
}

#infos >>> a {
    color: #969696;
    text-decoration: none;
}

@media screen and (min-width: 768px) {
    #infos >>> a:hover {
        color: white;
    }
}

#mobileImages {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
    margin-bottom: -0.4rem;
    margin: 1rem 1rem 0;
}

#mobileImages img {
    position: static;
    max-width: 100%;
    /*max-height: calc(100% - 2.5rem);*/
    max-height: calc(28vw - 2.6rem);
    width: auto;
    /*object-fit: contain;*/
    /*object-fit: cover;*/
}

#mobileImages img.double {
    width: calc(50% - 0.26rem);
    margin-left: 0.5rem;
    object-position: left;
}

#mobileImages img.double:first-child {
    margin-left: 0;
    object-position: right;
}

#mobileImages img.triple {
    width: calc(32% - 0.26rem);
    margin-left: 0.5rem;
    object-position: center;
}

#mobileImages > div {
    height: calc(33vw - 1rem);
    text-align: center;
    position: relative;
}

#mobileImages > div > p {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
}

.lightBorder {
    border: 0.5px solid #565656;
    box-sizing: border-box;
}

.darkBorder {
    border: 0.5px solid #202020;
    box-sizing: border-box;
}

.websiteImage {
    border-radius: 0.4rem;
}

@media screen and (min-width: 768px) {
    .lightBorder {
        border: 1px solid #565656;
        box-sizing: border-box;
    }

    .darkBorder {
        border: 1px solid #202020;
        box-sizing: border-box;
    }
}
.buttonNext,
.buttonPrev {
    position: absolute;
    top: 0;
    left: 0;
    width: 50%;
    height: 100%;
    cursor: w-resize;
    z-index: 2;
    display: none;
}
.buttonNext {
    left: 50%;
    cursor: e-resize;
}
.buttonPrev.random {
    width: 0;
}
.buttonNext.random {
    width: 100%;
    left: 0;
    cursor: pointer;
}
@media screen and (min-width: 768px) {
    .buttonNext,
    .buttonPrev {
        display: block;
    }
}

/* .swiper-container>>>.swiper-slide { */
/*     height: 100vh; */
/*     text-align: center; */
/*     display: flex; */
/*     justify-content: center; */
/*     align-items: center; */
/* } */
.appear-enter-active,
.appear-leave-active {
    transition: opacity 0.5s;
}

.appear-enter,
.appear-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
    opacity: 0;
}
</style>
